import { clsx } from 'clsx';
import { type FormikValues, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';

import { ErrorMessage } from '../index';
import classes from './FormCheckbox.module.scss';

type Props = {
	name: string;
	title: string;
	onPress?: (value: boolean, name: string) => void;
	firstValue: boolean;
	disabled?: boolean;
	displayError?: boolean;
};

const FormCheckbox: React.FC<Props> = ({
	name,
	title,
	onPress,
	firstValue = false,
	disabled = false,
	displayError = true,
}: React.PropsWithChildren<Props>) => {
	const { setFieldValue, errors, touched } = useFormikContext<FormikValues>();
	const [value, setValue] = useState<boolean | undefined>(firstValue);
	const [prevFirstValue, setPrevFirstValue] = useState(firstValue);

	const isError = !!touched[name] && !!errors[name];

	if (firstValue !== prevFirstValue) {
		setPrevFirstValue(firstValue);
		setValue(firstValue);
	}

	const handleOnPress = () => {
		const next = !value;
		setFieldValue(name, next);
		setValue(next);
		onPress?.(next, name);
	};

	useEffect(() => {
		setFieldValue(name, firstValue);
	}, [firstValue]);

	return (
		<div className={classes['wrapper']}>
			<button type="button" className={classes['container']} onClick={handleOnPress} disabled={disabled}>
				<div className={clsx(classes['iconContainer'], value && classes['iconContainerChecked'])}>
					{value && <span className={classes['checkmark']} />}
				</div>
				<span className={classes['text']}>{title}</span>
			</button>
			{displayError && <ErrorMessage error={errors[name] as string | undefined} visible={isError} />}
		</div>
	);
};

export default FormCheckbox;
